import { render, staticRenderFns } from "./loading-item.vue?vue&type=template&id=1f605935&lang=pug&"
import script from "./loading-item.vue?vue&type=script&lang=js&"
export * from "./loading-item.vue?vue&type=script&lang=js&"
import style0 from "./loading-item.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports